<template>
  <div class="page py-4">
    <ActionBar :breadcrumbItems="breadcrumbItems" />

    <div class="page--center-content">
      <Box :title="$t(`${namespace}.pageTitle`)" hover>
        <template v-slot:icon>
          <img :src="require('@/components/pages/requestToken/img/icon.svg')" alt="">
        </template>

        <div v-if="!form">
          <RequestInfo />
          <v-divider class="mx-2" />
          <HowToRequestInfo @showRequestTokenForm="showForm(true)" />
        </div>

        <Form v-else @submittedForm="showForm(false)" />
      </Box>
    </div>
  </div>
</template>

<script>
import ActionBar from 'components/Actionbar'
import RequestInfo from 'components/pages/requestToken/RequestInfo'
import HowToRequestInfo from 'components/pages/requestToken/HowToRequestInfo'
import Form from 'components/pages/requestToken/Form'

export default {
  name: 'RequestTokenPage',
  components: {
    ActionBar,
    RequestInfo,
    HowToRequestInfo,
    Form
  },
  data () {
    return {
      namespace: 'Views.RequestTokenPage',
      breadcrumbItems: [
        { name: 'RequestToken', title: this.$t('Views.RequestTokenPage.title') }
      ],
      form: false
    }
  },
  methods: {
    showForm (boolean = true) {
      this.form = boolean
    }
  }
}
</script>
